class SVG_Map {
    constructor() {
		this.init();
    }

    init() {
		let points = document.querySelectorAll('.svg-tooltip');
		if (!points) {
			console.log( '.svg-tooltip selector is not defined in DOM' );
			return;
		}


		if(points.length){
			Array.from(points).forEach( (point) => {

				point.addEventListener('mouseenter', ()=>{
					let tooltip = point.querySelector('g');
					tooltip.style.transform = 'translate(0, -50px)';
					$(tooltip).fadeIn();

				});

				point.addEventListener('mouseleave', ()=>{
					let tooltip = point.querySelector('g');
					setTimeout(()=>{
						if ( !$(point).is(':hover') ) {
							$(tooltip).fadeOut();
							tooltip.style.transform = 'translate(0, -60px)';
							//tooltip.setAttribute('transform', 'translate(0, -60)');
						}
					}, 100);
				});
			} );
		}
    }
}

export default SVG_Map;



// WEBPACK FOOTER //
// ./scripts/modules/svg-map.js